import { DatePicker, type DatePickerProps } from "$components/inputs";
import { useController } from "react-hook-form";

type RHFDatePickerProps = Partial<Omit<DatePickerProps, "value">> & {
  name: string;
};

const RHFDatePicker: FC<RHFDatePickerProps> = ({ name, ...delegateProps }) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
  });

  return (
    <DatePicker
      {...field}
      // We set "" here instead of as the default value to the controller so that RHF
      // isn't forced to hold null values, which can be problematic for validation,
      // but MUI is satisfied that the component is controlled on first render.
      value={field.value ?? null}
      error={error?.message}
      {...delegateProps}
    />
  );
};

export default RHFDatePicker;
